import { lazy } from "react";

const isChunkLoadError = (error) =>
  error?.name === "ChunkLoadError" ||
  /Loading chunk [\s\S]+ failed/i.test(String(error?.message || ""));

/**
 * Lazy import with automatic recovery when the browser holds a stale bundle
 * that references old chunk filenames (common after dev-server restarts).
 */
const lazyWithRetry = (importFn, key) =>
  lazy(async () => {
    const storageKey = `lazy-retry-${key}`;

    try {
      const module = await importFn();
      sessionStorage.removeItem(storageKey);
      return module;
    } catch (error) {
      if (!isChunkLoadError(error)) {
        throw error;
      }

      const attempts = Number(sessionStorage.getItem(storageKey) || "0");
      if (attempts < 2) {
        sessionStorage.setItem(storageKey, String(attempts + 1));
        const url = new URL(window.location.href);
        url.searchParams.set("_chunkRetry", String(Date.now()));
        window.location.replace(url.href);
        return new Promise(() => {});
      }

      sessionStorage.removeItem(storageKey);
      throw error;
    }
  });

export default lazyWithRetry;
